import { withRouter } from 'react-router-dom';
import List from '../components/List';

export default withRouter(List);